export const getFileName = (file) => {
  let spliceFileName = file.split("/");
  let fileName = spliceFileName[spliceFileName.length - 1];
  return fileName;
};
